import { render, staticRenderFns } from "./DatafieldValidationField.vue?vue&type=template&id=266f2ff0"
import script from "./DatafieldValidationField.vue?vue&type=script&lang=js"
export * from "./DatafieldValidationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports